import * as Popover from "@radix-ui/react-popover";
import { useBoolean } from "usehooks-ts";

import NotificationButton from "./panel/NotificationButton";
import NotificationOverlay from "./panel/NotificationOverlay";

import useLDFeatureFlag from "../launchdarkly/useLDFeatureFlag";
import { FeatureFlagKey } from "../launchdarkly/featureFlag";

const NotificationPanel = () => {
  const { data: enableAlerts } = useLDFeatureFlag(FeatureFlagKey.Alerts);
  const showOverlayBool = useBoolean();

  return (
    <Popover.Root
      open={showOverlayBool.value}
      onOpenChange={showOverlayBool.setValue}
    >
      {enableAlerts && <NotificationButton />}

      <NotificationOverlay onHide={showOverlayBool.setFalse} />
    </Popover.Root>
  );
};

export default NotificationPanel;
